import {
  useFetchNotifications,
  notificationsSlice,
} from '@wellesley/notifications'
import NotificationsPopover from '../../notifications/NotificationsPopover'
import { TitleBlock } from '../../../common/components/ToolbarItem/TitleBlock'
import { useIsItemActive } from '../../../common/components/ToolbarItem/hooks/useIsItemActive'
import { Bell } from 'lucide-react'
import { useSelector } from 'react-redux'
import BellDot from './bellDot.svg'
import { Tooltip } from '../../../common/components/Tooltip'

const id = 'notifications'

export const NotificationsItem = () => {
  const { isLoading } = useFetchNotifications({})

  const unreadNotifications = useSelector(
    notificationsSlice.selectors.selectUnreadNotifications,
  )

  const hasUnreadNotifications =
    unreadNotifications && unreadNotifications.length > 0

  const { isItemActive } = useIsItemActive(id)

  return (
    <NotificationsPopover isLoading={isLoading}>
      <Tooltip tooltipText="Notifications">
        <TitleBlock
          id={id}
          Icon={hasUnreadNotifications ? BellDot : Bell}
          variant="square"
          isCustomIcon={true}
          isItemActive={isItemActive}
        />
      </Tooltip>
    </NotificationsPopover>
  )
}
